import template from './vaccine.html';
import controller from './vaccine.controller';
import './vaccine.scss';

let vaccineComponent = {
  bindings: {},
  template,
  controller
};

export default vaccineComponent;



// WEBPACK FOOTER //
// ./client/app/components/vaccine/vaccine.component.js